// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FoundEntitiesList__container___IkxG6 {
    overflow: auto;

    width: 28rem;
    min-width: 28rem;
    padding-right: 0.8rem;
    padding-left: 0.8rem;
}

.FoundEntitiesList__item___qYC9V {
    cursor: pointer;

    display: flex;
    flex-grow: 1;
    align-items: center;

    margin-bottom: 0.4rem;

    border-radius: var(--control-radius);
}

.FoundEntitiesList__item___qYC9V:hover,
.FoundEntitiesList__itemActive___rjyns {
    background-color: var(--color-control-bg-clear-hover);
}

.FoundEntitiesList__iconWrapper___lAQDG {
    align-items: center;
    padding-right: 0.4rem;
    padding-left: 0.4rem;
}

.FoundEntitiesList__name____T8SX {
    flex-grow: 1;
    margin-right: 0.4rem;
}

.FoundEntitiesList__count___RArIS {
    padding-right: 0.4rem;
    padding-left: 0.4rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/OverallImport/NewImportResults/SearchResultsContent/FoundEntitiesList.css"],"names":[],"mappings":"AAAA;IACI,cAAc;;IAEd,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,eAAe;;IAEf,aAAa;IACb,YAAY;IACZ,mBAAmB;;IAEnB,qBAAqB;;IAErB,oCAAoC;AACxC;;AAEA;;IAEI,qDAAqD;AACzD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB","sourcesContent":[".container {\n    overflow: auto;\n\n    width: 28rem;\n    min-width: 28rem;\n    padding-right: 0.8rem;\n    padding-left: 0.8rem;\n}\n\n.item {\n    cursor: pointer;\n\n    display: flex;\n    flex-grow: 1;\n    align-items: center;\n\n    margin-bottom: 0.4rem;\n\n    border-radius: var(--control-radius);\n}\n\n.item:hover,\n.itemActive {\n    background-color: var(--color-control-bg-clear-hover);\n}\n\n.iconWrapper {\n    align-items: center;\n    padding-right: 0.4rem;\n    padding-left: 0.4rem;\n}\n\n.name {\n    flex-grow: 1;\n    margin-right: 0.4rem;\n}\n\n.count {\n    padding-right: 0.4rem;\n    padding-left: 0.4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FoundEntitiesList__container___IkxG6`,
	"item": `FoundEntitiesList__item___qYC9V`,
	"itemActive": `FoundEntitiesList__itemActive___rjyns`,
	"iconWrapper": `FoundEntitiesList__iconWrapper___lAQDG`,
	"name": `FoundEntitiesList__name____T8SX`,
	"count": `FoundEntitiesList__count___RArIS`
};
export default ___CSS_LOADER_EXPORT___;
